export const BETWEEN_HOURS = 'BETWEEN_HOURS';
export const MENU_HOURS_EXPIRED = 'MENU_HOURS_EXPIRED';
export const CHANGE_LOCATION = 'CHANGE_LOCATION';
export const CART_ITEMS_EXPIRED = 'CART_ITEMS_EXPIRED';
export const CART_NOT_FOUND = 'CART_NOT_FOUND';
export const CHECKOUT_NOT_POSSIBLE = 'CHECKOUT_NOT_POSSIBLE';
export const PROMOTION_DETAILS = 'PROMOTION_DETAILS';
export const FULFILLMENT_OPTION_NOT_AVAILABLE =
  'FULFILLMENT_OPTION_NOT_AVAILABLE';
export const MODIFIER_NOT_FOUND = 'MODIFIER_NOT_FOUND';
export const MENU_ITEM_NOT_ON_CURRENT_MENU = 'MENU_ITEM_NOT_ON_CURRENT_MENU';
export const FILTERED_MENU_ITEM_NOT_ON_CURRENT_MENU =
  'FILTERED_MENU_ITEM_NOT_ON_CURRENT_MENU';
export const SOLD_OUT_INVENTORY = 'SOLD_OUT_INVENTORY';
